﻿// ┌────────────────────────────────────────────────────────────────────
// │ Click to copy shows a toolip and gives and copies the text when clicked
// |
// | Usage: add class clickToCopy to elements that should receive a click to copy tooltip
// | and optionally set data-text to the text to be copied
// | 
// | Version Apr 7, 2025
// └────────────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
    ClickToCopy.setupElement();
});

globalThis.ClickToCopy = globalThis.ClickToCopy || {

    // Add click to copy to an element
    setupElement: function (element) {

        // Find all the elements with a clickToCopy class
        const elements = (element) ? element.querySelectorAll('.clickToCopy') : document.querySelectorAll('.clickToCopy');

        // Loop through all elements
        elements.forEach(element => {

            const text = element.innerText;

            if (!element.dataset.text)
                element.dataset.text = text;

            element.innerHTML = `${text}<span class="clickToCopy-text"><i class="fa-regular fa-clipboard-list"></i>Click to Copy</span>`;

            // Add click event listener
            element.addEventListener('click', function () {
                navigator.clipboard.writeText(element.dataset.text)
                    .then(() => {

                        const tooltip = this.querySelector('span');
                        tooltip.innerHTML = `<i class="fa-regular fa-circle-check"></i>Copied`;

                        setTimeout(() => tooltip.innerHTML = '<i class="fa-regular fa-clipboard-list"></i>Click to Copy', 1000);
                    })
                    .catch(err => {
                        console.error('Error copying text: ', err);
                    });
            });
        });
    }
};